import React from 'react';
import { useInput } from 'hooks';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import {
  IconPopover,
  isValidAccountNumberLength,
  isValidCardNumberLength,
  isValidSSNLength,
  InvalidFeedback,
} from 'common';
import './styles/commonForm.scss';
import { ReactComponent as Info } from 'images/info.svg';

const ForgotPasswordFormForOLB = ({ forgot }) => {
  const inputValidation = (inputs) => {
    let errors = {};
    errors.accountNumber = !(
      isValidAccountNumberLength(inputs.accountNumber) || isValidCardNumberLength(inputs.accountNumber)
    );
    return errors;
  };

  const { inputs, handleInputChange, handleBlur, errors } = useInput(inputValidation);

  const fieldValidation = ({ login = '', accountNumber = '', last4ssn = '' }) =>
    login.length > 0 &&
    (isValidAccountNumberLength(accountNumber) || isValidCardNumberLength(accountNumber)) &&
    isValidSSNLength(last4ssn);

  const FormButton = ({ children, submittedFields }) => (
    <Form.Group controlId="formSubmit">
      <Button variant="occu-primary" type="submit" block disabled={!fieldValidation(submittedFields)}>
        {children || 'Submit'}
      </Button>
    </Form.Group>
  );

  return (
    <div className="occu-form occu-form-wide">
      <h4>LET'S FIND YOU</h4>
      <Form
        name="forgotPasswordForm"
        id="forgotPasswordForm"
        onSubmit={(event) => {
          forgot(inputs.login, inputs.accountNumber, inputs.last4ssn);
          event.preventDefault();
        }}
      >
        <Form.Group controlId="formUser">
          <Form.Label className="form-label">Username</Form.Label>
          <Form.Control
            type="text"
            name="login"
            onChange={handleInputChange}
            value={inputs.login}
            autoComplete="off"
            required
          />
        </Form.Group>

        <Form.Group controlId="formNumber">
          <Form.Label className="form-label">Account Number or Card Number</Form.Label>

          <IconPopover
            content="If you do not have an active Orange County's Credit Union Debit/ATM or Credit Card, enter your Orange County's Credit Union Member Number"
            title="Information"
          >
            <Info className="icon" />
          </IconPopover>

          <Form.Control
            type="text"
            name="accountNumber"
            onChange={(event) => {
              event.target.value = event.target.value.replace(/[^0-9]/g, '');
              handleInputChange(event);
            }}
            maxLength={16}
            value={inputs.accountNumber}
            isInvalid={errors.accountNumber}
            onBlur={handleBlur}
            autoComplete="off"
            required
          />
          <InvalidFeedback type="memberNumber" />
        </Form.Group>

        <Form.Group controlId="formSSN">
          <Form.Label className="form-label">Last Four of SSN</Form.Label>
          <Form.Control
            type="password"
            name="last4ssn"
            onChange={(event) => {
              event.target.value = event.target.value.replace(/[^0-9]/g, '');
              handleInputChange(event);
            }}
            value={inputs.last4ssn}
            minLength={4}
            maxLength={4}
            required
            autoComplete="off"
          />
        </Form.Group>

        <FormButton submittedFields={inputs} />
      </Form>
    </div>
  );
};

export { ForgotPasswordFormForOLB };
